import NavbarPublico from '../components/NavbarPublico'

function Terminos() {
  return (
    <div style={estilos.pagina}>
      <NavbarPublico
        onIrALogin={() => { window.location.href = '/?login=1' }}
        onIrARegistro={() => { window.location.href = '/?registro=1' }}
        onIrAInicio={() => { window.location.href = '/' }}
        vistaActiva='legal'
      />
      <div style={estilos.contenido}>
        <h1 style={estilos.titulo}>Términos y Condiciones</h1>
        <p style={estilos.fecha}>Última actualización: 13 de abril de 2026</p>

        <h2 style={estilos.h2}>1. Objeto</h2>
        <p style={estilos.texto}>Los presentes Términos regulan el acceso y uso del servicio ETERN-ME, disponible en etern-me.com, desarrollado por Melina Rivera, Madrid, España.</p>

        <h2 style={estilos.h2}>2. Aceptación</h2>
        <p style={estilos.texto}>Al crear una cuenta aceptas estos Términos en su totalidad. Si no estás de acuerdo, no debes usar el servicio.</p>

        <h2 style={estilos.h2}>3. Descripción del servicio</h2>
        <p style={estilos.texto}>ETERN-ME es una plataforma de organización personal que permite guardar y gestionar información importante: cuentas y suscripciones digitales, documentos, instrucciones personales, contactos de confianza y mensajes programados. El servicio incluye un sistema de alerta de confianza que notifica a tus contactos designados si dejas de responder.</p>
        <p style={estilos.texto}>ETERN-ME no es un servicio jurídico ni un testamento digital con validez legal. No sustituye a un testamento notarial. Para dar validez jurídica a tus voluntades, debes formalizarlas ante notario. ETERN-ME puede servir como herramienta de preparación y organización previa a ese proceso.</p>

        <h2 style={estilos.h2}>4. Planes y pagos</h2>
        <p style={estilos.texto}>ETERN-ME ofrece 14 días de prueba gratuita sin tarjeta de crédito. Transcurrido este período, el acceso completo requiere un plan de pago. Los precios pueden modificarse con un aviso previo de 30 días. El usuario puede cancelar en cualquier momento.</p>

        <h2 style={estilos.h2}>5. Obligaciones del usuario</h2>
        <ul style={estilos.lista}>
          <li>Proporcionar información veraz y mantenerla actualizada</li>
          <li>Mantener la confidencialidad de sus credenciales de acceso</li>
          <li>No usar el servicio para fines ilícitos o fraudulentos</li>
          <li>Obtener el consentimiento de las personas cuyos datos introduce (herederos, contactos de confianza)</li>
          <li>No intentar acceder a cuentas o datos de otros usuarios</li>
        </ul>

        <h2 style={estilos.h2}>6. Eliminación de cuenta y datos</h2>
        <p style={estilos.texto}>El usuario puede eliminar su cuenta en cualquier momento desde "Mi perfil → Cuenta y privacidad → Eliminar cuenta". La eliminación es permanente e irreversible. Todos los datos personales, archivos, mensajes y configuraciones se borran de nuestros servidores en un plazo máximo de 30 días, conforme al RGPD.</p>

        <h2 style={estilos.h2}>7. Sistema de alerta de confianza</h2>
        <p style={estilos.texto}>El sistema de alerta depende de la respuesta activa del usuario a las notificaciones periódicas. ETERN-ME no garantiza la entrega si los datos de contacto son incorrectos o están desactualizados. El usuario es responsable de mantener actualizados los datos de sus contactos de confianza.</p>

        <h2 style={estilos.h2}>8. Mensajes póstumos y cápsulas del tiempo</h2>
        <p style={estilos.texto}>ETERN-ME hará todo lo posible por entregar los mensajes programados en las condiciones definidas por el usuario. Sin embargo, no podemos garantizar la entrega si los datos del destinatario son incorrectos, si la cuenta ha sido eliminada o si existen circunstancias técnicas de fuerza mayor.</p>

        <h2 style={estilos.h2}>9. Limitación de responsabilidad</h2>
        <p style={estilos.texto}>ETERN-ME no se responsabiliza de pérdidas o daños causados por interrupciones técnicas de terceros proveedores, uso incorrecto del servicio, datos incorrectos proporcionados por el usuario, o accesos no autorizados derivados de negligencia del usuario en la custodia de sus credenciales.</p>

        <h2 style={estilos.h2}>10. Responsabilidad sobre terceros añadidos</h2>
        <p style={estilos.texto}>
          El usuario es el único responsable de informar y obtener el consentimiento
          previo de las personas que añada como guardián o círculo de confianza en
          ETERN-ME. Al añadir a una persona, el usuario declara haber obtenido su
          consentimiento para recibir comunicaciones en su nombre.
        </p>
        <p style={estilos.texto}>
          ETERN-ME actúa únicamente como intermediario tecnológico y no se responsabiliza
          de las comunicaciones enviadas a terceros por instrucción del usuario.
        </p>

        <h2 style={estilos.h2}>11. Propiedad intelectual</h2>
        <p style={estilos.texto}>Todos los contenidos, diseño, código y marca de ETERN-ME son propiedad de Melina Rivera. El usuario conserva la propiedad de todos los datos e información que introduce en la plataforma.</p>

        <h2 style={estilos.h2}>12. Modificaciones</h2>
        <p style={estilos.texto}>Nos reservamos el derecho a modificar estos Términos con un aviso previo de 30 días. El uso continuado del servicio tras ese plazo implica la aceptación de los nuevos términos.</p>

        <h2 style={estilos.h2}>13. Cancelación</h2>
        <p style={estilos.texto}>Puedes cancelar tu suscripción en cualquier momento. No hay reembolsos por períodos parciales ya facturados. El acceso al servicio se mantiene hasta el final del período pagado.</p>

        <h2 style={estilos.h2}>14. Ley aplicable</h2>
        <p style={estilos.texto}>Estos Términos se rigen por la legislación española. Cualquier controversia se somete a los juzgados de Madrid, sin perjuicio de los derechos que correspondan al usuario como consumidor según la normativa europea aplicable.</p>
      </div>
      <footer style={estilos.footer}>
        <div style={estilos.footerContenido}>
          <p style={estilos.footerCopy}>2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera</p>
          <div style={estilos.footerLinks}>
            <a href="/privacidad" style={estilos.footerLink}>Privacidad</a>
            <a href="/terminos" style={estilos.footerLink}>Términos</a>
            <a href="/aviso-legal" style={estilos.footerLink}>Aviso Legal</a>
          </div>
        </div>
      </footer>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', flexDirection: 'column' },
  contenido: { maxWidth: '760px', margin: '0 auto', padding: '48px 24px', flex: 1 },
  titulo: { fontSize: '32px', fontWeight: '800', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  fecha: { fontSize: '13px', color: '#8B6F47', marginBottom: '40px' },
  h2: { fontSize: '18px', fontWeight: '700', color: '#2C1810', marginTop: '32px', marginBottom: '12px' },
  texto: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', marginBottom: '12px' },
  lista: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', paddingLeft: '24px', marginBottom: '12px' },
  footer: { backgroundColor: '#2C1810', padding: '24px 32px' },
  footerContenido: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  footerCopy: { color: '#ac9370', fontSize: '13px' },
  footerLinks: { display: 'flex', gap: '20px' },
  footerLink: { color: '#C4A882', fontSize: '13px', textDecoration: 'none' },
}

export default Terminos